import { SearchBarExpansive } from '@components/SearchBars';
import { getHotkeyHandler, useUncontrolled } from '@mantine/hooks';
import { useState } from 'react';

export interface SearchBarManufacturerCallbacks {
  onSuccess: VoidFunction;
}
interface SearchBarManufacturerProps {
  startSearch: (
    text: string,
    callbacks: SearchBarManufacturerCallbacks,
  ) => void;
  data: string[];
  onDataChange: (newValue: string[]) => void;

  onValueChange: (newValue: string) => void;

  allowEmptyString?: boolean;
}
export function SearchBarManufacturer(props: SearchBarManufacturerProps) {
  const {
    startSearch,
    data,
    onDataChange,
    onValueChange,
    allowEmptyString = false,
  } = props;
  const [searchTextManufactor, setSearchTextManufactor] = useState('');
  const [showErasedSearchManufactor, setShowErasedManufactor] = useState(false);
  const [loadingSearchManufactor, setLoadingSearchManufactor] = useState(false);
  const [alreadySearchManufactor, setAlreadySearchManufactor] = useState(false);

  const searchFuncManufactor = (input: string) => {
    setShowErasedManufactor(false);
    setSearchTextManufactor(input);
  };
  const startSearchManufactor = (input: string) => {
    if (input === '' && !allowEmptyString) return;
    setLoadingSearchManufactor(true);
    startSearch(input, {
      onSuccess() {
        setLoadingSearchManufactor(false);
        setShowErasedManufactor(true);
        setAlreadySearchManufactor(true);
      },
    });
  };

  const onPressEnterManufactor = getHotkeyHandler([
    ['Enter', () => startSearchManufactor(searchTextManufactor)],
  ]);

  const [_data, setData] = useUncontrolled({
    value: data,
    defaultValue: [],
    onChange: onDataChange,
  });

  return (
    <SearchBarExpansive
      showOptions={_data}
      setShowOptions={setData}
      searchText={searchTextManufactor}
      placeholder="Find a Manufacturer"
      loadingSearch={loadingSearchManufactor}
      alreadySearch={alreadySearchManufactor}
      showErasedSearch={showErasedSearchManufactor}
      searchOnKeyDown={onPressEnterManufactor}
      searchIconOnClick={() => startSearchManufactor(searchTextManufactor)}
      closeIconOnClick={() => {
        searchFuncManufactor('');
      }}
      searchOnChange={searchFuncManufactor}
      onClickFilter={input => {
        onValueChange(input);
        // const newFilterData = [...filterData.manufactorNames];
        // const filterExist = newFilterData.find(item => item.name.match(input));
        // if (!filterExist) {
        //   newFilterData.push({ name: input, active: true });
        //   dispatch(updateFilterManufactorNames(newFilterData));
        // }
        setData([]);
        // set filter
        // startSearch();
      }}
    />
  );
}
